import { Button, ButtonProps } from '@/components/ui/Button';
import { ConditionalWrapper } from '@/components/ui/ConditionalWrapper';
import { getRefDataLabel } from '@/lib/helpers/refData';
import { Link } from 'gatsby';
import React, { PropsWithChildren } from 'react';
import { formatDrupalUri } from '../../../../app/utils/string';
import { asyncTrackingEvent, asyncTrackingEventProps } from '../../../../app/utils/tracking';
import { Article } from '../../../../types/content';

export interface PrimaryCtaButtonProps extends PropsWithChildren<ButtonProps> {
  article: Article;
}

const PrimaryCtaButton = React.forwardRef<HTMLButtonElement, PrimaryCtaButtonProps>(
  ({ article, children, ...props }, ref) => {
    const r = new RegExp('^(?:[a-z]+:)?//', 'i');
    let primaryCTAExternalLink = false;
    if (article.primaryCtaLink && r.test(formatDrupalUri(article.primaryCtaLink))) {
      primaryCTAExternalLink = true;
    }

    return (
      <ConditionalWrapper
        condition={!!article.primaryCtaLink}
        wrapper={(children: any) => (
          <ConditionalWrapper
            condition={primaryCTAExternalLink}
            wrapper={(children: any) => (
              <Button asChild ref={ref} {...props}>
                <a
                  href={formatDrupalUri(article.primaryCtaLink)}
                  target="_blank"
                  data-cy={`link:view-primary-cta`}
                  onClick={() => {
                    if (article?.categories[0] && getRefDataLabel(article.categories[0]) === 'GradSims') {
                      const trackEvent: asyncTrackingEventProps = {
                        track: 'gradsims_article_button_click',
                        trackAbacus: 'gradsims_article_button_click',
                        trackTarget: article.primaryCtaLink ? article.primaryCtaLink : '',
                        trackText: 'GradSim'
                      };
                      asyncTrackingEvent(trackEvent);
                    }
                  }}
                >
                  {children}
                </a>
              </Button>
            )}
            OrWrapper={(children: any) => (
              <Button asChild ref={ref} {...props}>
                <Link to={formatDrupalUri(article.primaryCtaLink)} data-cy={`link:view-primary-cta`}>
                  {children}
                </Link>
              </Button>
            )}
          >
            {children}
          </ConditionalWrapper>
        )}
      >
        {article.primaryCtaLabel}
      </ConditionalWrapper>
    );
  }
);

export default PrimaryCtaButton;
